// extracted by mini-css-extract-plugin
export default {"badgesContainer":"styles_badgesContainer__hfQnn","badges":"styles_badges__ww7RC"};